import React, { useState } from "react";
import {
  IconButton,
  Menu,
  MenuItem,
  ListSubheader,
  Divider,
  Box,
  Typography,
  Button,
} from "@mui/material";
import SortIcon from "@mui/icons-material/Sort";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import Diversity3Icon from "@mui/icons-material/Diversity3";
import HdrOnIcon from "@mui/icons-material/HdrOn";
import WaterIcon from "@mui/icons-material/Water";
import HttpIcon from "@mui/icons-material/Http";

const SORT_OPTIONS = ["最新发布", "观看最多", "最早发布"];
const PLATFORM_OPTIONS = ["全部", "夜未央", "fansone", "推特", "onlyfans"];
const PEOPLE_OPTIONS = ["全部", "3P", "群P", "换妻", "群交", "双飞"];
const FINISH_OPTIONS = ["全部", "内射", "刷锅", "灌精", "吞精", "颜射"];
const TYPE_OPTIONS = [
  "全部",
  "淫妻绿帽",
  "媚黑",
  "双龙入洞",
  "野战",
  "露出",
  "SM",
  "露脸",
  "颜值",
];

const FilterMenuButton = ({
  onChange,
  CATEGORY_OPTIONS = [],
  showGroups = ["sort"],
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedSort, setSelectedSort] = useState("最新发布");
  const [selectedCategories, setSelectedCategories] = useState([]);

  const [shouldApply, setShouldApply] = useState(false); // ⭐ 关键：仅点击完成触发

  const open = Boolean(anchorEl);

  const handleOpen = (event) => setAnchorEl(event.currentTarget);

  // ⭐ onClose 只关闭，不触发搜索
  const handleClose = () => {
    setAnchorEl(null);
  };

  // ⭐ 点击完成才触发搜索
  const handleApply = () => {
    setShouldApply(true);
    handleClose();
    onChange?.({
      sort: selectedSort,
      categories: selectedCategories,
    });
  };

  const handleSelectSort = (value) => setSelectedSort(value);

  const handleSingleSelect = (options, value) => {
    const withoutGroup = selectedCategories.filter(
      (v) => !options.includes(v)
    );
    if (value === "全部") setSelectedCategories(withoutGroup);
    else setSelectedCategories([...withoutGroup, value]);
  };

  const handleSelectCategory = (value) => {
    const newCategories = selectedCategories.includes(value)
      ? selectedCategories.filter((v) => v !== value)
      : [...selectedCategories, value];
    setSelectedCategories(newCategories);
  };

  const selectedPlatform =
    PLATFORM_OPTIONS.find((p) => selectedCategories.includes(p)) || "全部";
  const selectedPeople =
    PEOPLE_OPTIONS.find((p) => selectedCategories.includes(p)) || "全部";
  const selectedFinish =
    FINISH_OPTIONS.find((p) => selectedCategories.includes(p)) || "全部";
  const selectedType =
    TYPE_OPTIONS.find((p) => selectedCategories.includes(p)) || "全部";

  const hasCategories =
    Array.isArray(CATEGORY_OPTIONS) && CATEGORY_OPTIONS.length > 0;

  const renderMenuItems = (options, selectedValue, onClickHandler) => (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        columnGap: 0.5,
      }}
    >
      {options.map((item) => (
        <MenuItem
          key={item}
          onClick={() => onClickHandler(item)}
          sx={{
            fontSize: 14,
            color: "#222",
            display: "flex",
            alignItems: "center",
            gap: 1,
            py: 0.5,
            "&:hover": { bgcolor: "rgba(255,255,255,0.4)" },
          }}
        >
          {selectedValue === item && <CheckIcon sx={{ fontSize: 16 }} />}
          <Typography variant="body2">{item}</Typography>
        </MenuItem>
      ))}
    </Box>
  );

  return (
    <>
      <IconButton
        onClick={handleOpen}
        sx={{
          color: "white",
          backgroundColor: "transparent",
          borderRadius: 2,
          "&:hover": { backgroundColor: "transparent" },
          boxShadow: "none",
        }}
      >
        <SwapVertIcon sx={{ color: "#000" }} />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose} // ⭐ 不触发搜索
        PaperProps={{
          sx: {
            mt: 1,
            px: 1,
            py: 0.5,
            minWidth: 230,
            borderRadius: 3,
            bgcolor: "rgba(255,255,255,0.7)",
            backdropFilter: "blur(10px)",
            boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
            display: "flex",
            flexDirection: "column",
            maxHeight: 400,
          },
        }}
      >
        {/* 关闭按钮 */}
        <IconButton
          size="small"
          onClick={handleClose}
          sx={{
            position: "absolute",
            top: 4,
            right: 4,
            backgroundColor: "rgba(255,255,255,0.4)",
            backdropFilter: "blur(5px)",
            "&:hover": { backgroundColor: "rgba(255,255,255,0.6)" },
          }}
        >
          <CloseIcon sx={{ fontSize: 18, color: "#000" }} />
        </IconButton>

        {/* 内容滚动区 */}
        <Box sx={{ overflowY: "auto", flex: 1, pr: 0.5 }}>
          {/* 排序 */}
          {showGroups.includes("sort") && (
            <>
              <ListSubheader
                disableSticky
                sx={{
                  bgcolor: "transparent",
                  fontSize: 13,
                  fontWeight: 600,
                  color: "#000",
                  display: "flex",
                  alignItems: "center",
                  gap: 0.8,
                  pl: 0.5,
                  pr: 3.5,
                }}
              >
                <SortIcon sx={{ fontSize: 18 }} /> 排序
              </ListSubheader>
              {renderMenuItems(SORT_OPTIONS, selectedSort, handleSelectSort)}
            </>
          )}

          {/* 人数 */}
          {showGroups.includes("people") && (
            <>
              <Divider sx={{ my: 0.5 }} />
              <ListSubheader
                disableSticky
                sx={{
                  bgcolor: "transparent",
                  fontSize: 13,
                  fontWeight: 600,
                  color: "#000",
                  pl: 0.5,
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                }}
              >
                <Diversity3Icon sx={{ fontSize: 18 }} /> 人数
              </ListSubheader>
              {renderMenuItems(PEOPLE_OPTIONS, selectedPeople, (val) =>
                handleSingleSelect(PEOPLE_OPTIONS, val)
              )}
            </>
          )}

          {/* 类型 */}
          {showGroups.includes("type") && (
            <>
              <Divider sx={{ my: 0.5 }} />
              <ListSubheader
                disableSticky
                sx={{
                  bgcolor: "transparent",
                  fontSize: 13,
                  fontWeight: 600,
                  color: "#000",
                  pl: 0.5,
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                }}
              >
                <HdrOnIcon sx={{ fontSize: 18 }} /> 类型
              </ListSubheader>
              {renderMenuItems(TYPE_OPTIONS, selectedType, (val) =>
                handleSingleSelect(TYPE_OPTIONS, val)
              )}
            </>
          )}

          {/* 射精方式 */}
          {showGroups.includes("finish") && (
            <>
              <Divider sx={{ my: 0.5 }} />
              <ListSubheader
                disableSticky
                sx={{
                  bgcolor: "transparent",
                  fontSize: 13,
                  fontWeight: 600,
                  color: "#000",
                  pl: 0.5,
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                }}
              >
                <WaterIcon sx={{ fontSize: 18 }} /> 射精方式
              </ListSubheader>
              {renderMenuItems(FINISH_OPTIONS, selectedFinish, (val) =>
                handleSingleSelect(FINISH_OPTIONS, val)
              )}
            </>
          )}

          {/* 平台 */}
          {showGroups.includes("platform") && (
            <>
              <Divider sx={{ my: 0.5 }} />
              <ListSubheader
                disableSticky
                sx={{
                  bgcolor: "transparent",
                  fontSize: 13,
                  fontWeight: 600,
                  color: "#000",
                  pl: 0.5,
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                }}
              >
                <HttpIcon sx={{ fontSize: 18 }} /> 平台
              </ListSubheader>
              {renderMenuItems(PLATFORM_OPTIONS, selectedPlatform, (val) =>
                handleSingleSelect(PLATFORM_OPTIONS, val)
              )}
            </>
          )}
        </Box>

        {/* 完成按钮 */}
        <Box
          sx={{
            mt: 1,
            px: 1,
            pt: 0.5,
            borderTop: "1px solid rgba(0,0,0,0.1)",
            position: "sticky",
            bottom: 0,
            bgcolor: "rgba(255,255,255,0.7)",
            backdropFilter: "blur(10px)",
            zIndex: 1,
          }}
        >
          <Button
            fullWidth
            onClick={handleApply} // ⭐ 只这里触发搜索
            sx={{
              background: "linear-gradient(90deg, #7b61ff, #5ac8fa)",
              color: "#fff",
              textTransform: "none",
              fontWeight: 600,
              fontSize: 14,
              borderRadius: 2,
              backdropFilter: "blur(6px)",
              "&:hover": { bgcolor: "rgba(0,0,0,0.5)" },
              py: 1,
            }}
          >
            完成
          </Button>
        </Box>
      </Menu>
    </>
  );
};

export default FilterMenuButton;
